import React from "react";
import { Users, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CustomersEmptyState({ searching, onAdd, onWalkIn }) {
  return (
    <div className="rounded-2xl border border-dashed border-slate-700 bg-slate-900/30 p-12 text-center" data-testid="customers-empty-state">
      <Users className="w-10 h-10 text-slate-600 mx-auto" />
      <p className="mt-3 font-semibold text-slate-300">{searching ? "No customers match your search" : "No customers yet"}</p>
      <p className="text-sm text-slate-500 font-zh">{searching ? "没有匹配的客户" : "添加第一位客户以开始"}</p>
      {!searching && (
        <Button onClick={onAdd} className="mt-5 bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold" data-testid="empty-add-customer-btn"><UserPlus className="w-4 h-4 mr-2" /> Add first customer</Button>
      )}
      <div className="mt-4">
        <button onClick={onWalkIn} data-testid="walkin-quote-link" className="text-sm text-amber-300 hover:text-amber-200 underline underline-offset-4">or start a walk-in quote without a customer →</button>
      </div>
    </div>
  );
}
